import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "invoiceableId", "invoiceableType", "checkboxesSection", "paymentMethodSelect" ]

  connect() {
    if(this.shouldHideCheckboxes()) this.hideCheckboxes();
  }

  hideInvoicable() {
    this.invoiceableIdTarget.hidden = this.shouldHideInvoicableId();
  }

  hideCheckboxes() {
    this.checkboxesSectionTarget.hidden = this.shouldHideCheckboxes();
  }

  shouldHideInvoicableId () {
    return this.invoiceableTypeTarget.value === "Foundation";
  }

  shouldHideCheckboxes() {
    return this.paymentMethodSelectTarget.value === "refund";
  }
};
